const createSequentialArray = (length: number): number[] => Array.from({ length }, (_, index) => index + 1);

const asyncFind = async <T>(array: T[], predicate: (value: T) => Promise<boolean>): Promise<T | undefined> => {
    for (const item of array) {
        const isMatch = await predicate(item);
        if (isMatch) {
            return item;
        }
    }
    return undefined;
};

const findMatchingValue = (value: string | string[], match: string): boolean => {
    if (Array.isArray(value)) {
        return value.includes(match);
    }
    return value === match;
};

const isNotEmpty = (array: unknown[]): boolean => {
    return array.length > 0;
};

const chunkArray = <T>(array: T[], chunkSize: number): T[][] => {
    const result: T[][] = [];
    for (let i = 0; i < array.length; i += chunkSize) {
        result.push(array.slice(i, i + chunkSize));
    }
    return result;
};

const matches = <T>(array: T[] | undefined, predicate: (value: T) => boolean): boolean => {
    return array?.some(predicate) ?? false;
};

const findByKeyValue = <T, K extends keyof T>(array: T[] | undefined, key: K, value: T[K]): T | undefined => {
    if (!array || array.length === 0) {
        return undefined;
    }

    return array.find((item) => item[key] === value);
};

export const ArrayHelpers = {
    createSequentialArray,
    asyncFind,
    findMatchingValue,
    isNotEmpty,
    chunkArray,
    matches,
    findByKeyValue,
};
